module.exports = __webpack_public_path__ + "img/20190814160801941.bd49ae86.png";